import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
const ease = [0.22, 1, 0.36, 1] as const;
export function Hero() {
  return <section id="inicio" className="relative overflow-hidden pt-32 lg:pt-40" data-id="element-61" data-mp="9ktfls818azv">
      <div aria-hidden="true" className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-accent/[0.07] blur-3xl" data-id="element-62" data-mp="9ip7sz70irub" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-6 pb-20 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:gap-16 lg:px-10 lg:pb-28" data-id="element-63" data-mp="128yxm77pblw0">
        <div data-id="element-64" data-mp="saruar6c52ch">
          <motion.span initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease
        }} className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-[13px] font-medium text-ink-soft shadow-soft" data-id="element-65" data-mp="sa9qn9hcfluj">
            <SparklesIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-66" data-mp="3814ehx9xecs1" />
            Estudio digital · Producto, web y automatización
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.08,
          ease
        }} className="mt-6 text-[2.6rem] font-semibold leading-[1.05] tracking-[-0.035em] text-ink sm:text-6xl lg:text-[4.1rem]" data-id="element-67" data-mp="3o6kh1mlj0k78">
            Construimos soluciones digitales que{' '}
            <span className="font-display font-normal italic text-accent" data-id="element-68" data-mp="358hncui19z33">impulsan</span> el
            crecimiento.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.16,
          ease
        }} className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-69" data-mp="2ql692kugw0za">
            En Almaria desarrollamos proyectos digitales modernos, escalables y enfocados en generar
            resultados para empresas, profesionales y emprendedores.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.24,
          ease
        }} className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-70" data-mp="nbbev44vul7x">
            <a href="#nosotros" className="group inline-flex items-center justify-center gap-2 rounded-full bg-accent px-6 py-3.5 text-[15px] font-medium text-white shadow-soft transition-all duration-200 hover:-translate-y-0.5 hover:bg-accent-dark hover:shadow-lift" data-id="element-71" data-mp="deq8aed7t21z">
              Conocer más
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-72" data-mp="x14mxv5tgi7f" />
            </a>
            <a href="#servicios" className="inline-flex items-center justify-center rounded-full border border-slate-200 bg-white px-6 py-3.5 text-[15px] font-medium text-ink shadow-soft transition-all duration-200 hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-lift" data-id="element-73" data-mp="3lqm4i498ffxk">
              Nuestros servicios
            </a>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.9,
        delay: 0.15,
        ease
      }} className="relative" data-id="element-74" data-mp="2b0pnv6mn30j3">
          <motion.div animate={{
          y: [0, -12, 0]
        }} transition={{
          duration: 7,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="overflow-hidden rounded-4xl border border-slate-200/80 bg-white shadow-lift" data-id="element-75" data-mp="2kyduattlxwh3">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/8c32ce2e-4e03-43f2-9626-3f9229263ff8.jpg" alt="Ilustración isométrica de un portátil con un panel de analítica y tarjetas de datos flotantes" className="h-full w-full object-cover" width={1200} height={900} data-id="element-76" data-mp="2tysgdveebfln" />
          </motion.div>

          <div className="absolute -bottom-6 left-4 hidden rounded-2xl border border-slate-200/80 bg-white/90 px-5 py-4 shadow-lift backdrop-blur sm:block" data-id="element-77" data-mp="3vhfdc3wxjvhn">
            <p className="text-2xl font-semibold tracking-[-0.02em] text-ink" data-id="element-78" data-mp="99xirg8shlgz">+250</p>
            <p className="text-xs font-medium uppercase tracking-[0.14em] text-slate-500" data-id="element-79" data-mp="3hq0rlpbn1g6w">
              Proyectos entregados
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}